import { render } from "./view-task.vue?vue&type=template&id=70b448f6"
import script from "./view-task.vue?vue&type=script&lang=js"
export * from "./view-task.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__